export default __webpack_public_path__ + "static/media/2001-2003.bd66dc88.png";